// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import SmileOutlined from '/apps/data/homepage/node_modules/.pnpm/@ant-design+icons@4.8.3_react-dom@19.1.1_react@19.1.1__react@19.1.1/node_modules/@ant-design/icons/es/icons/SmileOutlined';
export default { SmileOutlined };
